import React from 'react';
import { ButtonClean, Subsection } from '@fourthwall/components';
import { routing } from '@utils/routing';
export const VideosFields = () => (React.createElement(Subsection, { title: "Videos" },
    "You can add videos to series by editing them.",
    ' ',
    React.createElement(ButtonClean, { label: "Visit posts tab", withUnderline: true, to: routing.memberships.posts.self })));
